// extracted by mini-css-extract-plugin
module.exports = {"comp":"H_comp__Gtbn5"};